import { styled } from '../../../../core/theme/styled';

export const ThemedIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  & rect.primaryColor {
    fill: ${(props) => props.theme.configuration.primaryColor};
  }
  & rect.primaryColorAndBackground {
    fill: ${(props) => props.theme.configuration.backgroundColor};
    stroke: ${(props) => props.theme.configuration.primaryColor};
  }
  & path.primaryColor {
    fill: ${(props) => props.theme.configuration.primaryColor};
  }
  & path.primaryColorAndBackground {
    fill: ${(props) => props.theme.configuration.backgroundColor};
    stroke: ${(props) => props.theme.configuration.primaryColor};
  }
  & path.tintedBackground {
    fill: ${(props) => props.theme.configuration.tintedBackgroundColor};
  }
  & mask.backgroundColor {
    fill: ${(props) => props.theme.configuration.backgroundColor};
  }
`;
